



























































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import LaporanRegisterIgd, {
  RegisterIgdKolomKode,
  RegisterIgdKoreksiItem,
  RegisterIgdNilai,
  RegisterIgdResponse,
  RegisterIgdRow
} from "@/services/LaporanRegisterIgd";

interface OpsiItem {
  value: string;
  text: string;
}

interface OpsiGrup {
  label: string;
  opsi: OpsiItem[];
}

const FORMAT = "YYYY-MM-DD";
const MAX_PERIODE_HARI = 31;
const MAX_PDF_BARIS = 350;
const PER_HALAMAN = 100;
const KOLOM_KODE: RegisterIgdKolomKode[] = [
  "asal_rujukan",
  "pengantar",
  "penyebab",
  "kategori",
  "tindak_lanjut"
];
const KONFIRMASI_BUANG =
  "Ada isian yang belum disimpan. Lanjutkan dan buang perubahan tersebut?";

@Component({
  components: { "v-c-date-time-picker": VCDateTimePicker },
  beforeRouteLeave(to, from, next) {
    const vm = this as LaporanRegisterIgdPage;

    if (vm.jumlahBerubah > 0 && !window.confirm(KONFIRMASI_BUANG)) {
      next(false);
      return;
    }

    next();
  }
})
export default class LaporanRegisterIgdPage extends Vue {
  mulai = moment().format(FORMAT);
  selesai = moment().format(FORMAT);
  hariIni = moment().format(FORMAT);

  data: RegisterIgdResponse | null = null;
  periodeTermuat: { tgl_start: string; tgl_end: string } | null = null;
  edits: Record<string, RegisterIgdNilai> = {};
  rincian: Record<string, boolean> = {};

  loading = false;
  saving = false;
  printing = false;
  exporting = false;

  cari = "";
  hanyaBelumLengkap = false;
  halaman = 1;

  readonly kolomPilihAwal: RegisterIgdKolomKode[] = [
    "asal_rujukan",
    "pengantar",
    "penyebab"
  ];

  readonly labelKolom: Record<RegisterIgdKolomKode, string> = {
    asal_rujukan: "Asal Rujukan",
    pengantar: "Pengantar",
    penyebab: "Penyebab",
    kategori: "Kategori",
    tindak_lanjut: "Tindak Lanjut"
  };

  get tglMulai(): Date {
    return moment(this.mulai, FORMAT).toDate();
  }
  set tglMulai(val: Date) {
    this.mulai = this.keTanggalLokal(val, this.mulai);
  }

  get tglSelesai(): Date {
    return moment(this.selesai, FORMAT).toDate();
  }
  set tglSelesai(val: Date) {
    this.selesai = this.keTanggalLokal(val, this.selesai);
  }

  get jumlahHariPeriode(): number {
    return moment(this.selesai, FORMAT).diff(moment(this.mulai, FORMAT), "days") + 1;
  }

  get alasanPeriode(): string | null {
    if (!this.mulai || !this.selesai) return "Tanggal mulai dan selesai wajib diisi.";
    if (this.jumlahHariPeriode < 1) return "Tanggal selesai tidak boleh sebelum tanggal mulai.";
    if (this.jumlahHariPeriode > this.maxPeriodeHari) {
      return `Periode maksimal ${this.maxPeriodeHari} hari.`;
    }
    return null;
  }

  get periodeValid(): boolean {
    return this.alasanPeriode === null;
  }

  get maxPeriodeHari(): number {
    return this.data ? this.data.params.max_periode_hari : MAX_PERIODE_HARI;
  }

  get alasanPdfMati(): string | null {
    if (!this.periodeValid) return this.alasanPeriode;

    const maxBaris = this.data ? this.data.params.max_pdf_baris : MAX_PDF_BARIS;
    if (this.data && this.periodeSamaDenganTermuat && this.data.rows.length > maxBaris) {
      return `maksimal ${maxBaris} kunjungan per cetakan (periode ini ${this.data.rows.length}) — persempit periode atau gunakan Unduh Excel.`;
    }

    return null;
  }

  get periodeSamaDenganTermuat(): boolean {
    return (
      !!this.periodeTermuat &&
      this.periodeTermuat.tgl_start === this.mulai &&
      this.periodeTermuat.tgl_end === this.selesai
    );
  }

  get jumlahBerubah(): number {
    return Object.keys(this.edits).length;
  }

  get multiHari(): boolean {
    return !!this.data && this.data.params.jumlah_hari > 1;
  }

  get opsiKolom(): Record<string, OpsiItem[]> {
    const hasil: Record<string, OpsiItem[]> = {};
    if (!this.data) return hasil;

    const opsi = this.data.opsi;
    const peta: Record<string, Record<string, string>> = {
      asal_rujukan: opsi.asal_rujukan,
      pengantar: opsi.pengantar,
      kategori: opsi.kategori,
      tindak_lanjut: opsi.tindak_lanjut
    };

    Object.keys(peta).forEach(kolom => {
      hasil[kolom] = Object.keys(peta[kolom]).map(value => ({
        value,
        text: peta[kolom][value]
      }));
    });

    return hasil;
  }

  get opsiPenyebab(): OpsiGrup[] {
    if (!this.data) return [];
    const opsi = this.data.opsi;

    return Object.keys(opsi.penyebab_grup).map(key => ({
      label: opsi.penyebab_grup[key].label,
      opsi: opsi.penyebab_grup[key].kode.map(value => ({
        value,
        text: opsi.penyebab[value]
      }))
    }));
  }

  get kolomBelumLengkap(): { kolom: string; label: string; jumlah: number }[] {
    if (!this.data) return [];
    const belum = this.data.meta.belum_lengkap;

    return KOLOM_KODE.filter(k => belum[k] > 0).map(k => ({
      kolom: k,
      label: this.labelKolom[k],
      jumlah: belum[k]
    }));
  }

  get ringkasanBelumLengkap(): string {
    return this.kolomBelumLengkap.map(k => `${k.label}: ${k.jumlah}`).join(" · ");
  }

  get totalBelumLengkap(): number {
    return this.kolomBelumLengkap.reduce((t, k) => t + k.jumlah, 0);
  }

  get barisTersaring(): RegisterIgdRow[] {
    if (!this.data) return [];
    const kata = (this.cari || "").trim().toLowerCase();

    return this.data.rows.filter(row => {
      if (kata && row.nama.toLowerCase().indexOf(kata) < 0 && row.rm.indexOf(kata) < 0) {
        return false;
      }

      if (this.hanyaBelumLengkap) {
        return KOLOM_KODE.some(k => row.nilai[k] === null);
      }

      return true;
    });
  }

  get jumlahHalaman(): number {
    return Math.max(1, Math.ceil(this.barisTersaring.length / PER_HALAMAN));
  }

  get barisHalaman(): RegisterIgdRow[] {
    const awal = (this.halaman - 1) * PER_HALAMAN;
    return this.barisTersaring.slice(awal, awal + PER_HALAMAN);
  }

  mounted(): void {
    window.addEventListener("beforeunload", this.cegahTutup);
    this.tampilkan();
  }

  beforeDestroy(): void {
    window.removeEventListener("beforeunload", this.cegahTutup);
  }

  cegahTutup(ev: BeforeUnloadEvent): void {
    if (this.jumlahBerubah > 0) {
      ev.preventDefault();
      ev.returnValue = "";
    }
  }

  kembali(): void {
    this.$router.push({ name: "laporan-igd-menu" }).catch(() => undefined);
  }

  pilihHari(mundur: number): void {
    const tgl = moment().subtract(mundur, "days").format(FORMAT);
    this.mulai = tgl;
    this.selesai = tgl;
  }

  periode(): { tgl_start: string; tgl_end: string } {
    return { tgl_start: this.mulai, tgl_end: this.selesai };
  }

  async tampilkan(): Promise<void> {
    if (!this.periodeValid) return;
    if (this.jumlahBerubah > 0 && !window.confirm(KONFIRMASI_BUANG)) return;

    const periode = this.periode();
    this.loading = true;
    try {
      this.data = await LaporanRegisterIgd.get(periode);
      this.periodeTermuat = periode;
      this.edits = {};
      this.rincian = {};
      this.halaman = 1;
    } catch {
      this.data = null;
      this.periodeTermuat = null;
    } finally {
      this.loading = false;
    }
  }

  async simpan(): Promise<void> {
    if (!this.data || !this.periodeTermuat || this.jumlahBerubah === 0) return;

    const koreksi: RegisterIgdKoreksiItem[] = Object.keys(this.edits).map(id => ({
      register_id: Number(id),
      ...this.edits[id]
    }));

    this.saving = true;
    try {
      this.data = await LaporanRegisterIgd.save(this.periodeTermuat, koreksi);
      this.edits = {};
    } catch {
      return;
    } finally {
      this.saving = false;
    }
  }

  konfirmasiCetak(): boolean {
    if (this.jumlahBerubah === 0) return true;

    return window.confirm(
      "Ada isian yang belum disimpan. Berkas dibuat dari data yang sudah tersimpan — lanjutkan tanpa isian tersebut?"
    );
  }

  async cetak(): Promise<void> {
    if (this.alasanPdfMati || !this.konfirmasiCetak()) return;

    this.printing = true;
    try {
      await LaporanRegisterIgd.openPdf(this.periode());
    } catch {
      return;
    } finally {
      this.printing = false;
    }
  }

  async unduh(): Promise<void> {
    if (!this.periodeValid || !this.konfirmasiCetak()) return;

    this.exporting = true;
    try {
      await LaporanRegisterIgd.downloadExcel(this.periode());
    } catch {
      return;
    } finally {
      this.exporting = false;
    }
  }

  koreksiSaatIni(row: RegisterIgdRow): RegisterIgdNilai {
    return this.edits[row.register_id] || row.koreksi;
  }

  efektif(row: RegisterIgdRow, kolom: RegisterIgdKolomKode): string | null {
    const koreksi = this.koreksiSaatIni(row)[kolom];
    return koreksi !== null ? koreksi : row.rme[kolom];
  }

  efektifMeninggal(row: RegisterIgdRow): boolean {
    const koreksi = this.koreksiSaatIni(row).meninggal;
    return koreksi !== null ? koreksi : !!row.rme.meninggal;
  }

  koreksiKeterangan(row: RegisterIgdRow): string {
    return this.koreksiSaatIni(row).keterangan || "";
  }

  terapkan(row: RegisterIgdRow, perubahan: Partial<RegisterIgdNilai>): void {
    const baru: RegisterIgdNilai = { ...this.koreksiSaatIni(row), ...perubahan };
    const sama = (Object.keys(baru) as (keyof RegisterIgdNilai)[]).every(
      k => baru[k] === row.koreksi[k]
    );

    if (sama) {
      this.$delete(this.edits, String(row.register_id));
    } else {
      this.$set(this.edits, String(row.register_id), baru);
    }
  }

  ubahKode(row: RegisterIgdRow, kolom: RegisterIgdKolomKode, ev: Event): void {
    const nilai = (ev.target as HTMLSelectElement).value;
    const koreksi = nilai === "" || nilai === row.rme[kolom] ? null : nilai;
    this.terapkan(row, { [kolom]: koreksi } as Partial<RegisterIgdNilai>);
  }

  ubahMeninggal(row: RegisterIgdRow, ev: Event): void {
    const dicentang = (ev.target as HTMLInputElement).checked;
    this.terapkan(row, {
      meninggal: dicentang === !!row.rme.meninggal ? null : dicentang
    });
  }

  ubahKeterangan(row: RegisterIgdRow, ev: Event): void {
    const teks = (ev.target as HTMLInputElement).value;
    const rapi = teks.trim();
    this.terapkan(row, {
      keterangan: rapi === "" || rapi === (row.rme.keterangan || "") ? null : teks
    });
  }

  toggleRincian(row: RegisterIgdRow): void {
    if (this.rincian[row.register_id]) {
      this.$delete(this.rincian, String(row.register_id));
    } else {
      this.$set(this.rincian, String(row.register_id), true);
    }
  }

  kelasSel(row: RegisterIgdRow, kolom: RegisterIgdKolomKode): string {
    const edit = this.edits[row.register_id];
    if (edit && edit[kolom] !== row.koreksi[kolom]) return "sel-baru";
    if (this.efektif(row, kolom) === null) return "sel-kosong";
    if (this.koreksiSaatIni(row)[kolom] !== null) return "sel-koreksi";
    return "sel-rme";
  }

  kelasKeterangan(row: RegisterIgdRow): string {
    const edit = this.edits[row.register_id];
    if (
      edit &&
      (edit.keterangan !== row.koreksi.keterangan || edit.meninggal !== row.koreksi.meninggal)
    ) {
      return "sel-baru";
    }
    const koreksi = this.koreksiSaatIni(row);
    if (koreksi.keterangan !== null || koreksi.meninggal !== null) return "sel-koreksi";
    return "sel-rme";
  }

  judulSel(row: RegisterIgdRow, kolom: RegisterIgdKolomKode): string {
    const rme = row.rme[kolom];
    if (!this.data) return "";

    const label = rme
      ? kolom === "penyebab"
        ? this.data.opsi.penyebab[rme]
        : (this.opsiKolom[kolom] || []).find(o => o.value === rme)?.text || rme
      : null;

    return label
      ? `Menurut RME: ${label}`
      : "Belum tercatat di RME — pilih sesuai buku register";
  }

  teksOpsi(row: RegisterIgdRow, kolom: RegisterIgdKolomKode, o: OpsiItem): string {
    return row.rme[kolom] === o.value ? `${o.text} (RME)` : o.text;
  }

  labelBayar(kode: string | null): string {
    if (!kode || !this.data) return "-";
    return this.data.opsi.pembayaran[kode] || kode;
  }

  labelSumber(sumber: string | null): string {
    if (sumber === "icd") return "kode ICD";
    if (sumber === "asesmen") return "Asesmen Awal Medis Gadar";
    return "belum tercatat";
  }

  labelHari(tgl: string): string {
    return moment(tgl, FORMAT).locale("id").format("dddd, D MMMM YYYY");
  }

  private keTanggalLokal(val: Date | string | null, cadangan: string): string {
    if (val === null || val === undefined || val === "") return cadangan;
    const m = typeof val === "string" ? moment(val, [FORMAT, moment.ISO_8601]) : moment(val);
    return m.isValid() ? m.format(FORMAT) : cadangan;
  }
}
